import React from "react";
import { useTranslation } from "react-i18next";
import {
  Page,
  Card,
  TextContainer,
  SkeletonBodyText,
  SkeletonDisplayText,
  Banner,
} from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";

export default function LocationsImportShowSkeleton(props) {
  const { t } = useTranslation();
  
  return (
    <Page>
      <TitleBar
        title={t("import.show.title")}
        breadcrumbs={[{ content: t("import.breadcrumbs.locations"), url: "/places/locations" }]}
      />
      <Card
        sectioned
        primaryFooterAction={{
          content: t("import.new.uploadAndContinue"),
          loading: true,
        }}
      >
        <TextContainer>
          <SkeletonDisplayText />
          <SkeletonBodyText lines={4} />
          <SkeletonBodyText lines={2} />
        </TextContainer>
      </Card>
    </Page>
  );
}
